const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithubOriginal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-412c-22.09 0-40-17.91-40-40v-412c0-22.09 17.91-40 40-40H0c22.09 0 40 17.91 40 40v412C40-17.91 22.09 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(462 502)",
    fill: "#aaa",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c88.37 0 160-71.63 160-160 0-72.66-48.43-134.01-114.78-153.52-3.28 3.56-5.19 8.3-5.22 13.52v39.82c.03 18.31-7.22 23.14-12.51 31.22 83.61 12.48 86.24 89.36 57.04 123.94-.45.52-.86 1.51-.67 2.07 4.48 13.54 3.9 43.36-6.35 42.89-14.04-.65-25.24-8.56-38.27-16.31-.99-.58-1.78-.81-2.93-.5C24.33-73.62 12.22-71.86 0-71.71c-12.22-.15-24.33-1.91-36.31-5.16-1.15-.31-1.94-.08-2.93.5-13.03 7.75-24.23 15.66-38.27 16.31-10.25.47-10.83-29.35-6.35-42.89.19-.56-.22-1.55-.67-2.07-29.2-34.58-26.57-111.46 57.04-123.94-5.29-8.08-12.54-12.91-12.51-31.22V-300c-.03-5.22-1.94-9.96-5.22-13.52C-111.57-294.01-160-232.66-160-160-160-71.63-88.37 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(256 396)",
    fill: "#ffffff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c5.52 0 10-4.48 10-10S5.52-20 0-20s-10 4.48-10 10S-5.52 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(376 469)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c5.67.49 10.67-1.48 15.28-4.561C20.44-8.01 24.25-12.67 27.4-17.97c4.35-7.33 10.201-12.99 18.59-15.46 9.18-2.71 17.97-.95 26.521 2.72",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(141.14 165.37)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-66.351 19.51-114.78 80.859-114.78 153.52 0 88.37 71.63 160 160 160s160-71.63 160-160C205.22 80.859 156.79 19.51 90.439 0 76.1-4.221 60.93-6.48 45.22-6.48S14.34-4.221 0 0Z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(210.78 82.48)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-412c-22.09 0-40 17.91-40 40v412c0 22.09 17.91 40 40 40H0c22.09 0 40-17.91 40-40V40C40 17.91 22.09 0 0 0Z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(462 10)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 20,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h200",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(136 459)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.279 3.56 5.189 8.3 5.22 13.52v39.82c-.031 18.309 7.219 23.139 12.509 31.22-83.609 12.479-86.24 89.36-57.04 123.94.451.52.861 1.51.67 2.069-4.479 13.54-3.899 43.361 6.351 42.891 14.04-.65 25.24-8.561 38.269-16.311.991-.58 1.781-.809 2.931-.5 11.98 3.25 24.09 5.01 36.31 5.161 12.219-.151 24.33-1.911 36.309-5.161 1.151-.309 1.941-.08 2.931.5 13.029 7.75 24.229 15.661 38.269 16.311 10.25.47 10.831-29.351 6.351-42.891-.19-.559.22-1.549.67-2.069 29.2-34.58 26.569-111.461-57.04-123.94C78 76.479 85.25 71.649 85.22 53.34V13.52C85.25 8.3 87.16 3.56 90.439 0",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(210.78 82.48)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubOriginal);
export default __webpack_public_path__ + "static/media/github_original.d356109cf8fb542ea19ee6aec0af6a91.svg";
export { ForwardRef as ReactComponent };